export default {
    setTareasProgramadas(state, t) {
        state.tareasProgramadas = t;
    }
}